module.exports = __webpack_public_path__ + "static/media/loc6_img10.6d1ad9c7.jpg";